const deadzone = 0.25 // 0-1 Middle zone to avoid switching back to rapid
const drag = 0.4 // Slowdown movement
const lerpAmount = 0.3 // Tween time
const idle = .5 // Seconds before switching
const easing = null // easeInOutCubic

function easeInOutExpo(x: number) {
	return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2
}

function easeInOutCubic(x: number) {
	return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
}

function lerp(start: number, end: number, amount: number) {
	return (1 - amount) * start + amount * end
}

export class StateSwitcher {
	currentValue: number
	targetValue: number

	timeout: number

	direction: boolean

	isAnimating = false

	target: HTMLElement
	customProperty: string
	toggleAttribute: string

	constructor(target: HTMLElement, customProperty: string = 'animation', toggleAttribute: string = 'alt') {
		this.target = target
		this.customProperty = customProperty
		this.toggleAttribute = toggleAttribute
	}

	input(value: number) {
		if ((!this.direction && value > (.5 + deadzone / 2)) || (this.direction && value < (.5 - deadzone / 2))) {
			this.direction = !this.direction
			this.target.style.transition = null
			this.target.toggleAttribute(this.toggleAttribute, this.direction)
		} else {
			if (!this.direction) {
				value = value * drag
			} else {
				value = 1 - ((1 - value) * drag)
			}
			if (easing) value = easing(value)

			this.targetValue = value
			if (!this.isAnimating) {
				this.isAnimating = true
				requestAnimationFrame(this.animate.bind(this))
			}
			clearTimeout(this.timeout)
			if (idle) this.timeout = window.setTimeout(this.snap.bind(this), idle * 1000, value)
		}
	}

	animate() {
		this.currentValue = lerp(this.currentValue, this.targetValue, lerpAmount)

		if (Math.abs(this.currentValue - this.targetValue) > .000001) {
			requestAnimationFrame(this.animate.bind(this))
		} else {
			this.currentValue = this.targetValue
			this.isAnimating = false
		}

		this.target.style.setProperty(`--${this.customProperty}`, this.currentValue.toString())
	}

	snap(value: number) {
		this.targetValue = Math.round(value)
		if (!this.isAnimating) {
			this.isAnimating = true
			requestAnimationFrame(this.animate.bind(this))
		}
		this.target.style.transition = null
		this.target.toggleAttribute(this.toggleAttribute, this.direction)
		clearTimeout(this.timeout)
	}
}
